export const errCreateCompany =
  "Se ha producido un error al crear la empresa, compruebe que el email no esté asociado a una cuenta";

export const unkonwnError =
  "Se ha producido un error, intente de nuevo más tarde o contacto con su administrador";

export const loginError =
  "Se ha producido un error al logearse, compruebe email y contraseña";
